:host {
  display: flex;
  align-items: center;
  padding: var(--spacing-m, $spacing-m);
  justify-content: space-between;
  border-radius: 0 0 var(--radius-m, $radius-m) var(--radius-m, $radius-m);
  border-top: 1px solid var(--border-color-primary, border-color('primary'));
  background-color: var(--background-color-secondary, background-color('secondary'));
}

.keyboard-shortcuts {
  display: flex;
  align-items: center;
  gap: var(--spacing-m, $spacing-m);
}

.shortcut-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs, $spacing-xs);
  font-size: $font-size-md;
}

.shortcut-description {
  color: var(--text-color-tertiary, text-color('tertiary'));
}

.shortcut-icon {
  color: var(--text-color-tertiary, text-color('tertiary'));
  display: flex;
  align-items: center;
  border-radius: var(--radius-xs, $radius-xs);
  background: var(--background-color-fourth, background-color('tertiary'));
  border: 0.7px solid var(--border-color-primary, border-color('primary'));
  justify-self: flex-end;
  padding: pxToRem(4);
  justify-content: center;
}

.arrows-container {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs, $spacing-xs);
}

.esc-text {
  font-size: 0.7rem;
}

.powered-by {
  display: flex;
  align-items: flex-end;
  text-align: right;
  flex-grow: 1;
  justify-content: right;
  gap: var(--spacing-s, $spacing-s);
}

.logo-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-s, $spacing-s);
  text-decoration: none;

  &:focus-visible {
    outline: none;
    border: 1px solid var(--border-color-accent, border-color('accent'));
  }
}

.logo {
  max-width: pxToRem(62);
}

@media (max-width: 768px) {
  :host {
    flex-direction: column;
    gap: var(--spacing-m, $spacing-m);
  }

  .keyboard-shortcuts {
    display: none;
  }

  .powered-by {
    justify-content: center;
  }
}
